export default class Price {
  id: number
  depositPriceCents: number

  constructor(attrs: any) {
    this.id = attrs.id
    this.depositPriceCents = attrs.depositPriceCents
  }
}
